import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Button from "../../../components/common/Button/Button";
import FormInput from "../../../components/common/FormInput/FormInput";
import UploadImage from "../../../components/common/UploadImage/UplaodImage";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import { addCustomPageGallery } from "../../../api/service/custompage.service";

const AddCustomPageGallery = () => {
  const navigate = useNavigate();
  const { id, slug } = useParams(); 
  const [loading, setLoading] = useState(false);


  const [formData, setFormData] = useState({
    page_id: id || "", 
    title: "",
    description: "",
    slug: slug, 
    category: "",
  });

  const [image, setImage] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  useEffect(() => {
    setFormData((prev) => ({ 
      ...prev, 
      page_id: id || prev.page_id,
      slug: slug || prev.slug
    }));
  }, [id, slug]);
// console.log(formData?.slug,"alug....")


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleFileSelect = (file) => {
    setImage(file);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.page_id) {
      showToast.error("Page ID is missing");
      return;
    }

    if (!formData.title.trim()) {
      showToast.error("Please enter title");
      return;
    }

    if (!formData.description.trim()) {
      showToast.error("Please enter description");
      return;
    }

    if (!formData.category.trim()) {
      showToast.error("Please enter category");
      return;
    }

    if (!image) {
      showToast.error("Please upload image");
      return;
    }

    try {
      setLoading(true);
      const submitData = new FormData();
      submitData.append("page_id", formData.page_id); 
      submitData.append("title", formData.title.trim());
      submitData.append("description", formData.description.trim());
      submitData.append("slug", formData.slug);
      submitData.append("category", formData.category.trim());
      submitData.append("image", image);

      const response = await addCustomPageGallery(submitData);

      if (response.success) {
        showToast.success(response.message || "Gallery added successfully!");
        navigate(-1);
      } else {
        showToast.error(response.message || "Failed to add gallery");
      }
    } catch (error) {
      console.error("Add Gallery Error:", error);
      showToast.error(
        error?.response?.data?.message || "Failed to add gallery"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex gap-2 align-items-center mb-3">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
        />
        <h3 className="management-tile mb-0">Add Gallery</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Row>
          <Col xs={12} className="mb-3">
            <label className="form-label">
              Title <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              name="title"
              value={formData.title}
              placeholder="Enter title"
              onChange={handleInputChange}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Description <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              type="textarea"
              name="description"
              value={formData.description}
              placeholder="Enter description"
              onChange={handleInputChange}
              rows={4}
              required
            />
          </Col>

          {/* <Col xs={12} className="mb-3">
            <label className="form-label">Slug</label>
            <FormInput
              name="slug"
              value={formData.slug}
              placeholder="Enter slug (optional)"
              onChange={handleInputChange}
            />
          </Col> */}

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Category <span style={{ color: "red" }}>*</span>
            </label>
            <FormInput
              name="category"
              value={formData.category}
              placeholder="Enter category"
              onChange={handleInputChange}
              required
            />
          </Col>

          <Col xs={12} className="mb-3">
            <label className="form-label">
              Image <span style={{ color: "red" }}>*</span>
            </label>
            <UploadImage onFileSelect={handleFileSelect} />
          </Col>

          <Col xs={12}>
            <Button type="submit" disabled={loading}>
              {loading ? "Adding..." : "Add Gallery"}
            </Button>
          </Col>
        </Row>
      </form>
    </>
  );
};

export default AddCustomPageGallery;